import pantoneLogo from '@icons/other3/pantone-logo.svg';

export default {
  pantone: pantoneLogo,
};
